export default __webpack_public_path__ + "static/media/microphone.a2833274.webp";